import { FC } from 'react'
import styles from './SingleCard.module.scss'
import { SingleCardProps } from './SingleCard.types'
import { Type } from 'components/Type'
import { Icon } from 'components/Phantom/Icon'

export const SingleCard: FC<SingleCardProps> = (props) => {
	const { title, description, checks } = props
	return (
		<div className={styles.container}>
			<header>
				<Type.Headline6>{title}</Type.Headline6>
				<Type.Body3>{description}</Type.Body3>
			</header>
			<ul className={styles.checks}>
				{checks.map((check) => (
					<li key={check}>
						<Type.Body2>
							<Icon
								name="CheckDark"
								color="#A0A0A0"
							/>
							{check}
						</Type.Body2>
					</li>
				))}
			</ul>
		</div>
	)
}
